import React, { lazy } from 'react';
import Loadable from "../commoncomponents/loadabl/loadable";
import Layout from "../layout/layout";

const Index = Loadable(lazy(() => import("../pages/index")));
const About = Loadable(lazy(() => import("../pages/about")));
const Book = Loadable(lazy(() => import("../pages/book")));
const Contact = Loadable(lazy(() => import("../pages/contact")));
const Dan = Loadable(lazy(() => import("../pages/dan")));
const Disclaimer = Loadable(lazy(() => import("../pages/disclaimer")));
const EquipmentRental = Loadable(lazy(() => import("../pages/equipment-rental")));
const Gallery = Loadable(lazy(() => import("../pages/gallery")));
const MultipurposeStudio = Loadable(lazy(() => import("../pages/multipurpose-studio")));
const PodcastStudio = Loadable(lazy(() => import("../pages/podcast-studio")));
const PrivacyPolicy = Loadable(lazy(() => import("../pages/privacy-policy")));
const RecordingStudio = Loadable(lazy(() => import("../pages/recording-studio")));
const ReserveSlot = Loadable(lazy(() => import("../pages/reserve-slot")));
const TermsOfService = Loadable(lazy(() => import("../pages/terms-of-service")));

const PublicRoutes = {
  path: '/',
  element: <Layout />,
  children: [
    { path: '/', element: <Index /> },
    { path: 'about', element: <About /> },
    { path: 'book', element: <Book /> },
    { path: 'contact', element: <Contact /> },
    { path: 'dan', element: <Dan /> },
    { path: 'disclaimer', element: <Disclaimer /> },
    { path: 'equipment-rental', element: <EquipmentRental /> },
    { path: 'gallery', element: <Gallery /> },
    { path: 'multipurpose-studio', element: <MultipurposeStudio /> },
    { path: 'podcast-studio', element: <PodcastStudio /> },
    { path: 'privacy-policy', element: <PrivacyPolicy /> },
    { path: 'recording-studio', element: <RecordingStudio /> },
    { path: 'reserve-slot', element: <ReserveSlot /> },
    { path: 'terms-of-service', element: <TermsOfService /> },
  ],
};

export default PublicRoutes;